import { combineReducers } from 'redux';

import { delegatedKeyAuthorizationReducer } from './authorizationReducer';
import { delegatedKeySettingsReducer } from './settingsReducer';

export const delegatedKeyReducer = combineReducers({
  authorization: delegatedKeyAuthorizationReducer,
  settings: delegatedKeySettingsReducer,
});
